import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;

export const Img = styled.img`
	width: fit-content;
	height: 70px;
`;

export const TextWrapper = styled.div`
	margin-top: 20px;
`;
